export default {
  rpa: {
    metadata: {
      title: 'Automate Repetitive Tasks with RPA: Efficient Solutions for Your Business',
      desc: 'Discover how RPA can transform your business by optimizing processes and increasing your team’s productivity. Talk to our experts and learn about the benefits.',
    },
    hero: {
      title: '<span class="font-black">Transform Your Repetitive Processes</span> with Intelligent Automation',
    },
    monthlyPlans: {
      title: '<span class="font-black">Monthly plans</span> for you to get the best of RPA!',
      desc: '<span class="font-black">Robotic Process Automation (RPA)</span> is a solution that automates activities, reduces costs for your company, allows your team to focus on truly strategic tasks, and offers the possibility of subscribing to the service monthly. Let us explain it better!',
    },
    whyChooseRpa: {
      title: 'Why Choose RPA?',
      cards: [
        {
          title: 'Greater Operational Efficiency:',
          text: 'Automate repetitive tasks and free your team for more strategic activities that generate real value for your business.',
        },
        {
          title: 'Security and Compliance:',
          text: 'Manage and control tasks in a unified and dynamic way, with total security and reliability.',
        },
        {
          title: 'Fewer Errors and Failures:',
          text: 'Robots execute tasks 24/7 with a high level of excellence and accuracy.',
        },
        {
          title: 'Cost Reduction:',
          text: 'Save time and operational costs with an efficient workforce.',
        },
        {
          title: 'Return on Investment:',
          text: 'Achieve ROI in a short time with automations that add value to your operations.',
        },
        {
          title: 'Improved Customer Experience:',
          text: 'Resolve customer issues, requests, and inquiries faster, contributing to an increase in customer retention.',
        },
      ],
    },
    featuresOurSolution: {
      title: 'Our Solution’s Conveniences',
      list: [
        {
          title: 'SaaS Model:',
          text: 'With this model there’s no need for your company to install, maintain, and update hardwares or softwares. Easy and simple access done via internet connection.',
        },
        {
          title: 'Low Development Costs:',
          text: 'If your company lacks an IT team, no problem. Our team of experts handles the entire development and support for the platform implementation process.',
        },
        {
          title: 'Subscription Model:',
          text: 'Pay monthly for the service and choose when you want to use it.',
        },
        {
          title: 'Suitable for All Company Sizes:',
          text: 'Doesn’t matter your company’s size, our solution works, and is efficient for all types of businesses.',
        },
        {
          title: 'No Need for Licenses and Installations:',
          text: 'Use the service only when needed.',
        },
      ],
      button: 'I want to know about RPA!',
    },
    rpaImplementation: {
      title: 'With Our RPA Implementation, You Get:',
      button: 'Transform Your Routine with RPA!',
      cards: [
        {
          icon: 'Icon732',
          title: 'Integration',
          list: [
            'Integration with multiple tools, applications, websites, AI, Machine Learning, and any digital document.',
            'Automation of any task through native integration with over 500 applications.',
            'Data extraction from 3,000 types of documents in more than 80 languages using OCR technologies.',
          ],
        },
        {
          icon: 'Icon730',
          title: 'Strategy',
          list: [
            'Highly scalable.',
            'Service-based acquisition with monthly payment.',
            'Adaptable to businesses of all sizes.',
            'Free employees for more strategic tasks.',
            'Continuous support included in the subscription.',
          ],
        },
        {
          icon: 'Icon728',
          title: 'Security',
          list: ['Compliant with information security and GDPR.', 'Improves compliance, reducing risks and fraud.'],
        },
      ],
    },
    applicable: {
      title: 'Where Can RPA Be Applied?',
      cards: [
        {
          icon: 'icon710',
          title: 'Finance',
          list: ['Payable/Receivable Accounts Reconciliation;', 'Bank Reconciliation;', 'Invoice Issuance.'],
        },
        {
          icon: 'icon712',
          title: 'Administrative',
          list: ['Issuance and Capture of Tax Invoices;', 'Bank Reconciliation.'],
        },
        {
          icon: 'icon723',
          title: 'Healthcare',
          list: ['Updating Health Plans;', 'Invoices and Reports Issuance for Clients;', 'Claims Control.'],
        },
        {
          icon: 'icon717',
          title: 'Industry',
          list: ['Order Registration;', 'Exit Records Issuance;', 'Bid Search.'],
        },
        {
          icon: 'icon714',
          title: 'Logistics',
          list: ['DRE Assessment;', 'Managerial Information Generation;', 'Delivery Tracking and Collection.'],
        },
        {
          icon: 'icon721',
          title: 'Customer Service',
          list: ['Customer Information Search;', 'Lead Management for Support;', 'Service Efficiency Monitoring.'],
        },
        {
          icon: 'icon725',
          title: 'Legal',
          list: ['Case Closure Processing;', 'Claims Closure Processing;', 'Contract Completion.'],
        },
        {
          icon: 'icon719',
          title: 'Purchasing',
          list: ['Order Registration;', 'Customer Search;', 'Price Research.'],
        },
      ],
    },
    counterPartnership: {
      title: 'Count on <br><span class="font-black">Our Partnership!</span>',
      list: [
        `• <span class="font-black">Team of experts in RPA</span> and other technology services;`,
        `• <span class="font-black">Over 20 years of experience</span> in the tech industry;`,
        `• Creation, maintenance, and support of <span class="font-black">customized bots made just for you</span>;`,
        `• <span class="font-black">Affordable and flexible pricing</span> tailored to your company;`,
        `• <span class="font-black">Monthly contracts</span> to optimize costs;`,
        `• Extra layers of <span class="font-black">security</span>.`,
      ],
    },
    talkToUs: {
      title: 'We are ready to meet your needs.',
      button: 'Learn More About RPA!',
    },
  },
}
